export const CaretLeft = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 24L20 8L10 16L20 24Z" fill="currentColor"/>
</svg>`;
